import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { privacyPolicy } from '@/api/PrivacyPolicy';

@Component
export default class PrivacyPolicyMixin extends Vue {
  privacyModal = false;

  privacyText = '';

  async showCookieSettings() {
    if (!this.privacyText) {
      try {
        const result = await privacyPolicy({
          lang: AppModule.language,
          type: 'jobimpuls',
          sid: AppModule.sid,
        });
        this.privacyText = result.text || AppModule.translation[12816] || '';
      } catch (e) {
        this.privacyText = AppModule.translation[12816] || '';
      }
    }
    this.privacyModal = true;
  }
}
